import React, { useEffect } from 'react';
import { useParams, useNavigate, NavLink } from 'react-router-dom';
import '../styles/profile.css'

function LawyerProfile({ lawyers }) {
    const { id } = useParams();
    const navigate = useNavigate();
    const lawyer = lawyers.find(lawyer => lawyer.id === id || lawyer.id === parseInt(id));

    useEffect(() => {
        if (lawyers.length > 0 && !lawyer) {
            navigate('/team');
        }
    }, [lawyer, lawyers, navigate]);

    if (lawyers.length === 0) {
        return <div>Cargando...</div>;
    }

    if (!lawyer) {
        return null; // Ya se está redirigiendo
    }

    return (
        <div>
            {/* ZOOM CONTAINER TEAM */}
            <div className='zoom-container-profile pt-2 d-flex justify-content-center align-items-center flex-column'>
                <div className='zoom-bg-profile'></div>
                <div className='text-center mt-5 zoom-container-profile-text'>
                    <span className='zoom-container-span-team'>NUESTRO</span>
                    <span className='zoom-container-span-team fw-bold'>EQUIPO</span>
                </div>
            </div>

            <div className='d-flex justify-content-center align-items-center mt-4 mb-5 d-flex flex-column'>
                <div className='profile-container col-lg-10 d-flex justify-content-center align-items-center gap-5'>

                    <img src={`${process.env.PUBLIC_URL}${lawyer.image}`} alt={lawyer.name} className="Profile-img" />

                    <div className='profile-text'>
                        <h1 className='name-profile'>{lawyer.name}</h1>
                        <h1 className='area-profile'>{lawyer.area}</h1>
                        <br />
                        <p className='profile-profile' dangerouslySetInnerHTML={{ __html: lawyer.profile }} />


                        <div className='d-flex align-items-center gap-2 pt-3 profile-icons'>
                            <img src={`${process.env.PUBLIC_URL}/img/profile/mail.svg`} alt={lawyer.name} className="mail-svg" />
                            <p className="email-profile">{lawyer.email}</p>
                        </div>
                        <div className='d-flex align-items-center gap-2 pt-3 profile-icons'>
                            <img src={`${process.env.PUBLIC_URL}/img/profile/phone.svg`} alt={lawyer.name} className="mail-svg" />
                            <p className="email-profile">+57 {lawyer.phone}</p>
                        </div>

                    </div>
                </div>
                <NavLink to="/team" className="profile-buttom">Nuestro equipo</NavLink>
            </div>
        </div>
    );
}

export default LawyerProfile
